<template>
  <div class="top-info pa-4 d-flex flex-column ga-2" :class="{view: tapStore.view}"
       :style="{background: color.background.value, color: color.color.value}">
    <div class="have-changes" v-if="!tapStore.view && tapStore.currentTapLang?.infoChanged && tapStore?.currentTap?.status.id == 3">
      <div class="text">
        {{$t('Изменения не опубликованы')}}
      </div>
    </div>
    <div class="d-flex justify-space-between align-start">
      <div class="flex-1">
        <v-hover>
          <template v-slot:default="{ isHovering, props }">
            <v-icon :icon="SettingsIcon" v-bind="props" :color="isHovering ? 'primary' : color.color.value" size="20" class="cursor-pointer settings-icon " :class="{'hidden': tapStore.view}" @click="openBackgroundDialog"/>
          </template>
        </v-hover>
      </div>
      <div class="flex-1 d-flex justify-center">
        <div class="avatar-border" :class="{'cursor-pointer': !tapStore.view}" @click="openImageDialog" v-if="!tapStore.view || (tapStore.view && tapStore.currentTap?.image)">
          <v-skeleton-loader type="avatar" v-if="tapStore.currentTap?.imageLoading"/>
          <v-avatar size="120" :icon="AddAvatarIcon" :image="tapStore.currentTap?.image" color="BW-100-BG" v-else/>
        </div>
      </div>
      <div class="flex-1 d-flex justify-end" v-if="!tapStore.view">
        <div class="lang-button" @click="openLangDialog" :class="{'hidden': !tapStore.currentTapLang?.lang}">
          <template v-if="tapStore.currentTapLang?.lang">
            {{$t(`${tapStore.currentTapLang?.lang}-code`)}}
          </template>
          <template v-else>
            РУ
          </template>
        </div>
      </div>
      <div v-if="tapStore.view" class="d-flex align-center ga-2 flex-1 justify-end">
        <div class="block-switcher" v-if="tapStore.currentTapLang && activeLanguages.length > 1">
          <div class="lang-switch" :class="{select}" :style="{'--hover-switcher-background': color.background.value, '--switcher-background': 'transparent', '--switcher-color': color.color.value}" @click="toggleDialog">
            {{ $t(`${tapStore.currentTapLang?.lang}-code`) }}
            <div class="lang-dialog" :class="{select}">
              <div class="lang-dialog-content">
                <router-link class="item" :to="{path: editProfile ? `/profile/${tapStore.currentTap?.alias}/view/${lang.lang.toLowerCase()}` : `/${tapStore.currentTap?.alias}/${lang.lang.toLowerCase()}`, query: $route.query}" v-for="lang of activeLanguages">
                  {{ $t(lang.lang) }}
                  <svg v-if="tapStore.currentTapLang?.lang == lang.lang" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="#0D87EF"></circle><path d="M7.5 12L10.5 15L16.5 9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div>
          <v-tooltip location="bottom end" :disabled="tapStore?.currentTap?.status.id == 3"
                     :text="tapStore?.currentTap?.status.id != 3 ? $t('Сначала опубликуйте страницу') : ''">
            <template v-slot:activator="{ props }">
              <ShareIcon class="share-icon" :class="{
            'cursor-pointer': tapStore?.currentTap?.status.id == 3,
            'cursor-not-allowed': tapStore?.currentTap?.status.id != 3
          }"
                         :color="color.color.value" @click="openShareDialog" v-bind="props">
              </ShareIcon>
            </template>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div class="text-information d-flex flex-column ga-2 pa-2" @click="openDescriptionDialog" :class="{'cursor-pointer': !tapStore.view, 'highlighted-element': showOnboarding, 'cursor-default': tapStore.view}"
         v-if="!tapStore.view || (tapStore.view && (tapStore.currentTapLang?.name || tapStore.currentTapLang?.description))">
      <div class="name" v-if="!tapStore.view || (tapStore.view && tapStore.currentTapLang?.name)">{{ tapStore.currentTapLang?.name ? tapStore.currentTapLang?.name : $t('Название страницы') }}</div>
      <div class="description" v-if="!tapStore.view || (tapStore.view && tapStore.currentTapLang?.description)">
        {{ tapStore.currentTapLang?.description ? tapStore.currentTapLang?.description : $t('Описание') }}
      </div>
      <v-menu
          :model-value="showOnboarding"
          location="bottom"
          z-index="2222"
          activator="parent"
          offset="4"
          :max-width="'100%'"
          :close-on-content-click="false"
          transition="fade-transition"
          @update:model-value="sentHint"
      >
        <div class="d-flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="10" viewBox="0 0 40 10" fill="none">
            <path d="M19.9508 0L16.9419 2.99887C12.4434 7.48242 6.35102 10 -0.000296474 10L39.9019 10C33.5506 10 27.4583 7.48242 22.9597 2.99887L19.9508 0Z" fill="white"/>
          </svg>
        </div>
        <div class="onboarding">
          {{$t('Коснитесь любого блока, чтобы начать редактирование')}}
          <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="sentHint">
            {{ $t('Понятно') }}
          </v-btn>
        </div>
      </v-menu>
    </div>

    <v-btn variant="flat" color="primary" rounded="lg" class="w-100" @click="openSocialDialog" v-if="!tapStore.currentTapLang?.socials?.length && !tapStore.view">
      <template v-slot:prepend>
        <v-icon :icon="AddIcon" color="'secondary'" size="24"/>
      </template>
      {{ $t('Добавить соцсети') }}
    </v-btn>
    <div v-else-if="tapStore.currentTapLang?.socials?.length" class="text-information links-data d-flex px-10 ga-2 pt-2 pb-2" :class="{'cursor-pointer': !tapStore.view}" @click="openSocialDialog">
      <a :href="item.link" v-if="tapStore.view" v-for="item in tapStore.currentTapLang?.socials" @click="addClick(item.uniqueId)" target="_blank">
        <img :src="`/socials/${tapStore.currentTapLang?.socialView !== 'black' && tapStore.currentTapLang?.socialView !== 'white' ? 'default' : tapStore.currentTapLang?.socialView}/${socialIcon.detectSocialIcon(item.link)}`"
             :alt="item.type"
             :class="tapStore.currentTapLang?.socialView">
      </a>
      <img v-for="item in tapStore.currentTapLang?.socials"
           :src="`/socials/${tapStore.currentTapLang?.socialView !== 'black' && tapStore.currentTapLang?.socialView !== 'white' ? 'default' : tapStore.currentTapLang?.socialView}/${socialIcon.detectSocialIcon(item.link)}`"
           :alt="item.type"
           :class="tapStore.currentTapLang?.socialView"
           v-else>
    </div>
  </div>



  <v-overlay
      :model-value="showOnboarding"
      :scrim="true"
      opacity="0.7"
      persistent
      style="z-index: 2000"
  />
</template>


<script setup lang="ts">
import SettingsIcon from "~/assets/icons/settings.vue";
import AddAvatarIcon from '~/assets/icons/add-avatar.vue'
import AddIcon from '~/assets/icons/add.vue'
import { useTapStore } from '@/stores/tapStore'
import {useDialogStore} from "@/stores/dialogStore";
import {useHintStore} from "@/stores/hintStore";
import Social from "@/components/dialogs/Social.vue";
import Description from "@/components/dialogs/Description.vue";
import Image from "@/components/dialogs/Image.vue";
import Background from "@/components/dialogs/Background.vue";
import { useBGColor } from '@/composables/useBGColor'
import {computed, onMounted, ref, watch} from "vue";
import ShareIcon from "~/assets/icons/share.vue";
import Lang from "@/components/dialogs/Language.vue";
import {useRoute} from "vue-router";
import ShareDialog from "@/components/dialogs/ShareDialog.vue";
import {useSocialIcon} from "~/composables/useSocialIcon";
const onboarding = ref(false)
const tapStore = useTapStore()
const userStore = useUserStore()
const dialogStore = useDialogStore()
const hintStore = useHintStore()
const color = useBGColor()
const socialIcon = useSocialIcon()

const openShareDialog = () => {
  if(tapStore?.currentTap?.status.id != 3) return
  dialogStore.open(ShareDialog, {
    alias: tapStore.currentTap.alias,
    name: tapStore.currentTapLang.name,
    image: tapStore.currentTap.image,
    lang: tapStore.currentTapLang.lang.toLowerCase(),
    defaultLang: tapStore.currentTap.projectVersion.defaultLang.toLowerCase()
  })
}

const openSocialDialog = () => {
  if(!tapStore.view) {
    dialogStore.setRightPadding(false)
    dialogStore.open(Social)
  }
}

const openBackgroundDialog = () => {
  if(!tapStore.view) {
    dialogStore.open(Background)
  }
}

const addClick = (uniqueId: any) => {
  tapStore.addClick(tapStore.currentTap?.id, uniqueId, tapStore.currentTapLang?.lang)
}

const openDescriptionDialog = () => {
  if(!tapStore.view) {
    dialogStore.open(Description)
  }
}

const openImageDialog = () => {
  if(!tapStore.view) {
    dialogStore.open(Image)
  }
}

const openLangDialog = () => {
  if(!tapStore.view) {
    dialogStore.open(Lang)
  }
}

const showOnboarding = computed(() => {
  return !!onboarding.value && hintStore.canShow('block_editing')
})

const activeLanguages = computed(() => {
  return tapStore.currentTap?.projectVersion.languageSettings.filter(item => item.active)
})

if(tapStore?.currentTapLang) {
  color.setBGColor(tapStore?.currentTapLang?.backgroundColor)
}

onMounted(() => {
  color.setBGColor(tapStore?.currentTapLang?.backgroundColor)
  if(userStore.isAuth) {
    hintStore.checkHint('block_editing').then(result => {
      onboarding.value = !result
      if(onboarding.value) {
        hintStore.viewHint('block_editing')
      }
    })
  }
})

watch(() => tapStore?.currentTapLang?.backgroundColor, (n) => {
  color.setBGColor(tapStore?.currentTapLang?.backgroundColor)
})
const route = useRoute()
const editProfile = computed(() => /^\/profile\/[^\/]+\/(edit|view)(\/(ru|kz|en))?\/?$/.test(route.path))

const sentHint = () => {
  onboarding.value = false
  hintStore.closeHint('block_editing')
}

const select = ref<boolean>(false)

const toggleDialog = () => {
  if ('ontouchstart' in window) {
    select.value = !select.value
  }
}
</script>

<style scoped lang="sass">
.top-info
  background: #fff
  border-radius: 20px
  &.view
    border-radius: 0 0 20px 20px
    justify-content: center
    .avatar-border
      border: none
      &:hover
        border: none
    .text-information
      border: none
      &:hover
        border: none


  .settings-icon
    margin: 6px
    &.hidden
      visibility: hidden

  .avatar-border
    border-radius: 9px
    border: 1px dashed #DEE2E6
    height: fit-content
    &:hover
      border: 1px dashed #0D87EF


  .lang-button
    border-radius: 9px
    border: 1px dashed #DEE2E6
    padding: 6px 9px
    height: fit-content
    cursor: pointer
    &.hidden
      visibility: hidden
    &:hover
      border: 1px dashed #0D87EF

  .share-icon
    outline: none

  .text-information
    border-radius: 9px
    border: 1px dashed #DEE2E6
    &:hover
      border: 1px dashed #0D87EF

    .name
      text-align: center
      font-size: 20px
      font-weight: 600
      line-height: normal
      overflow: hidden
      text-overflow: ellipsis
    .description
      text-align: center
      font-size: 16px
      font-weight: 400
      line-height: normal
      white-space: pre-wrap
      overflow: hidden
      text-overflow: ellipsis
    .default
      width: 24px
      height: 24px
    .default-bg
      width: 40px
      background: #F6F7F8
      height: 40px
      padding: 8px
      border-radius: 12px
  .links-data
    justify-content: center
    flex-wrap: wrap

.have-changes
  display: flex
  align-items: center
  overflow: hidden
  .text
    color: #B20320
    text-overflow: ellipsis
    font-size: 10px
    font-weight: 400
    line-height: normal
    white-space: nowrap
    overflow: hidden
    width: 100%
    text-align: center

.highlighted-element
  z-index: 2100 !important
  background-color: white !important

.onboarding
  padding: 20px
  background: #fff
  display: flex
  justify-content: center
  flex-direction: column
  gap: 16px
  border-radius: 10px
  max-width: 100%
  color: #363636
  text-align: center
  font-size: 16px
  font-weight: 400
  line-height: 130%

.flex-1
  flex: 1

.block-switcher
  position: relative
  display: flex
  align-items: center
  justify-content: center
  .lang-switch
    height: 40px
    width: 40px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 8px
    color: var(--switcher-color)
    cursor: pointer
    position: relative
    background: var(--switcher-background)
    &.select
      background: var(--hover-switcher-background)
    @media (hover: hover) and (pointer: fine)
      &:hover
        background: var(--hover-switcher-background)
        .lang-dialog
          display: block
  .lang-dialog
    position: absolute
    top: 100%
    right: 0
    display: none
    padding-top: calc(25% + 14px)
    margin-top: calc(-25%)
    z-index: 1
    &.select
      display: block
    &-content
      border-radius: 10px
      background: #fff
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1)
      padding: 16px
      flex-direction: column
      display: flex
      .item
        padding: 10px 16px
        border-radius: 8px
        text-decoration: none
        white-space: nowrap
        color: #363636
        display: flex
        align-items: center
        justify-content: space-between
        min-width: 177px
        &:hover
          background: #F6F7F8
</style>
